import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Backdrop, CircularProgress, Typography, Box } from "@mui/material";

interface Props {
  allowedRoles: number[];
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<Props> = ({ allowedRoles, children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Backdrop
        open
        sx={{
          color: "#fff",
          zIndex: theme => theme.zIndex.drawer + 1,
          flexDirection: "column",
        }}>
        <CircularProgress color="primary" />
        <Box mt={2}>
          <Typography variant="h6">Loading, please wait...</Typography>
        </Box>
      </Backdrop>
    );
  }

  if (!user) {
    return <Navigate to="/signin" />;
  }

  const hasAccess = user.roles?.some((role: number) =>
    allowedRoles.includes(role),
  );

  if (!hasAccess) {
    return <Navigate to="/403" />;
  }

  return <>{children}</>;
};
